const CountInstanceDetailsActionTypes = {
	SHOW_EDIT_COUNT_INSTANCE_MODAL: 'SHOW_EDIT_COUNT_INSTANCE_MODAL',
	SHOW_SEND_NOTIFICATION_MODAL: 'SHOW_SEND_NOTIFICATION_MODAL',
	SEND_NOTIFICATION_START: 'SEND_NOTIFICATION_START',
	SEND_NOTIFICATION_FAILURE: 'SEND_NOTIFICATION_FAILURE',
	SEND_NOTIFICATION_SUCCESS: 'SEND_NOTIFICATION_SUCCESS',
};

export default CountInstanceDetailsActionTypes;
